import { ReactElement, useState } from 'react'
import {
  Dialog,
  DialogContent,
  Stack,
  Typography,
  TextField,
  InputAdornment,
  DialogActions,
  Button,
  MenuItem,
} from '@mui/material'
import { useModelStore } from '@editorStores'

const ProjectInfo = (): ReactElement => {
  const project = useModelStore(state => state.project)

  const [configOpen, setConfigOpen] = useState(false)

  return (
    <>
      <MenuItem onClick={() => setConfigOpen(true)}>Info</MenuItem>

      <Dialog open={configOpen} onClose={() => setConfigOpen(false)}>
        <DialogContent dividers>
          <Stack direction="column" spacing={2}>
            <Typography variant="h6">Erdbeschleunigung</Typography>
            <Stack direction="row" alignItems="center">
              <Typography>
                Die folgende Erdbeschleunigung wird in diesem Projekt verwendet. Falls gewünscht
                kann das DEV Team diese auch nachträglich anpassen.
              </Typography>

              <TextField
                value={project?.earth_mass_force}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="end">m/s²</InputAdornment>,
                  },
                }}
                disabled
              />
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setConfigOpen(false)}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ProjectInfo
